(ns hai.library.sources.documents-table
  "Documents table and modal"
  (:require
   [clojure.string :as str]
   [com.wsscode.pathom3.connect.operation :as pco]
   [hai-model.model :as model]
   [hai.ui.components :as c]
   [hai.ui.components.collection.filters :as filters]
   [hai.ui.components.card :as card]
   [hai.ui.components.collection.table :as collection]
   [hai.ui.components.collection.views.cards :as cards]
   [hai.ui.components.collection.views.table :as table]
   [hai.ui.components.form.select.single-select :as single-select]))

(defn title-render
  [file]
  (let [source-type (get-in file [:ai-source/_documents :ai-source/type])
        source-uuid (get-in file [:ai-source/_documents :ai-source/uuid])
        file-uuid (:ai-file/uuid file)
        ;; For file sources, use the download endpoint; for others use citation-link
        href (if (= :file source-type)
               (str "/assistant/v0/sources/" source-uuid "/files/" file-uuid "/download")
               (:ai-file/citation-link file))]
    [table/table-cell
     [c/Link
      {:style {:cursor "pointer"}
       :href href
       :target "_blank"
       :variant "ghost"}
      (:ai-file/title file)]]))

(defn status-render [file]
  [table/table-cell
   (let [status (or (:ai-file/status file) :processing)
         color (case status
                 :done "green"
                 :processing "orange"
                 :error "red"
                 "gray")]
     [c/Badge {:color color :radius "full" :variant "solid" :p "2"}
      (-> status name str/capitalize)])])

(defn documents-table
  [source]
  (let [ident (model/->ident source)]
    [collection/component
     {:id [::source-files-table ident]
      :paginate? true
      :no-items (fn [_] [:em "No source documents found"])
      :query [{ident [{:user.source-files/table
                       [{:collection/items
                         [:ai-file/uuid
                          :ai-file/title
                          :ai-file/status
                          (pco/? :ai-file/citation-link)
                          :ai-source/_documents]}]}]}]
      ;; TODO default card render
      :card (fn [collection item]
              [card/card
               [cards/card-select-checkbox collection item]
               [cards/column-render collection item]])
      :columns [{:header "Title"
                 :render title-render
                 :attr   :ai-file/title
                 :filter (filters/text-search {:placeholder "Document's title..."})
                 :sort?  true}
                {:header "Status"
                 :render status-render
                 :attr   :ai-file/status
                 :filter {:schema      :keyword
                          :type        :filter.remote/select
                          :placeholder "Status..."
                          :field       single-select/field}
                 :sort?  true}]
      :bulk-actions [{:title    "Delete"
                      :mutation 'ai-file/delete}]}]))

(defn documents-modal
  [source open? on-close]
  (let [doc-count (count (:ai-source/documents source))
        source-title (:ai-source/title source)
        source-uuid (:ai-source/uuid source)
        type-label (:ai-source/type-label source)]
    [c/DialogRoot
     {:open         open?
      :onOpenChange (fn [open?]
                      (when-not open?
                        (on-close)))}
     [c/DialogContent {:max-width "700px"}
      [c/DialogTitle "Documents"]
      [c/dialog-close-x]
      [c/DialogDescription
       (str "Viewing " doc-count " document" (when (not= doc-count 1) "s")
            " from \"" source-title "\" (" type-label " source). ")]
      [c/Box {:py "4"}
       ;; Key forces remount when document count changes, triggering table refetch
       ^{:key (str source-uuid "-" doc-count)}
       [documents-table source]]
      [c/Flex {:justify "end" :gap "3" :mt "4"}
       [c/DialogClose
        [c/Button {:variant "soft"} "Close"]]]]]))
